import { useRef } from "react";

export function useHorizontalScroll() {
    
    const scrollRef = useRef<HTMLDivElement>(null);

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
        isDown = true;
        startX = e.pageX - (scrollRef.current?.offsetLeft || 0);
        scrollLeft = scrollRef.current?.scrollLeft || 0;
    };

    const handleMouseUp = () => {
        isDown = false;
    };

    const handleMouseLeave = () => {
        isDown = false;
    };

    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
        if (!isDown) return;

        e.preventDefault();
        const x = e.pageX - (scrollRef.current?.offsetLeft || 0);
        const walk = (x - startX) * 1;

        if (scrollRef.current) {
            scrollRef.current.scrollLeft = scrollLeft - walk;
        }
    };

    return {
        scrollRef,
        handleMouseDown,
        handleMouseUp,
        handleMouseLeave,
        handleMouseMove,
    };
}